<template>
  <v-dialog v-model="dialog" max-width="560">
    <v-card v-if="dialog">
      <v-card-title>{{ $t('charging-point.start-charge.title') }}</v-card-title>
      <v-card-text>
        <!-- La charge technique, sans membre : le rôle Superviseur seulement. -->
        <v-radio-group v-if="canTechnical" v-model="mode" class="mt-0" hide-details>
          <v-radio value="member" :label="$t('charging-point.start-charge.for-member')" />
          <v-radio value="technical" :label="$t('charging-point.start-charge.technical')" />
        </v-radio-group>

        <template v-if="mode === 'member'">
          <v-autocomplete
              v-model="memberId"
              class="mt-4"
              :label="$t('charging-point.start-charge.member')"
              :items="members"
              :loading="loading"
              :search-input.sync="searchText"
              item-text="name"
              item-value="id"
              :no-data-text="$t('charging-point.start-charge.no-member')"
              no-filter
              clearable
              autocomplete="nope"
          >
            <template #item="{item}">
              <v-list-item-content>
                <v-list-item-title>{{ item.name || '-' }}</v-list-item-title>
                <v-list-item-subtitle>{{ [item.evcoId, item.organization].filter(Boolean).join(' · ') }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <div class="text-caption text--secondary mt-2">{{ $t('charging-point.start-charge.for-member-hint') }}</div>
        </template>
        <template v-else>
          <v-alert type="warning" dense text class="mt-4">
            {{ $t('charging-point.start-charge.technical-hint') }}
          </v-alert>
          <v-textarea
              v-model="reason"
              :label="$t('charging-point.start-charge.reason')"
              :hint="$t('charging-point.start-charge.reason-hint')"
              persistent-hint
              outlined
              dense
              rows="2"
              auto-grow
          />
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn small text @click="dialog = false">{{ $t('cancel') }}</v-btn>
        <v-btn small color="primary" :loading="sending" :disabled="mode === 'member' ? !memberId : !reason.trim()" @click="start">
          {{ $t('charging-point.remote-start-session') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CommandRepository from "@repository/CommandRepository";

// Démarrer une charge à distance : pour un membre (ses droits, sa facturation), ou, avec le rôle Superviseur, une charge
// technique sans membre (gratuite, plafonnée, motif obligatoire).
export default {
  props: {
    chargingPointId: String,
  },

  data() {
    return {
      dialog: false,
      evseId: null,
      mode: 'member',
      memberId: null,
      reason: '',
      members: [],
      searchText: '',
      loading: false,
      sending: false,
    }
  },

  computed: {
    canTechnical() {
      return (this.currentUser?.permissions || []).includes('TECHNICAL_CHARGE')
    },
  },

  watch: {
    searchText(text) {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => this.loadMembers(text), 250)
    },
  },

  methods: {
    open(evseId) {
      this.evseId = evseId
      this.mode = 'member'
      this.memberId = null
      this.reason = ''
      this.members = []
      this.dialog = true
      this.loadMembers('')
    },

    loadMembers(searchText) {
      this.loading = true
      CommandRepository.chargeableMembers(this.chargingPointId, searchText || '').then(result => {
        this.members = result.items
      }).catch(err => {
        this.notifyError(err)
      }).finally(() => {
        this.loading = false
      })
    },

    start() {
      this.sending = true
      const request = this.mode === 'member'
        ? CommandRepository.startChargeForMember(this.evseId, this.memberId)
        : CommandRepository.remoteStartSession(this.evseId, this.reason.trim())
      request.then(() => {
        this.dialog = false
        this.$emit('started', this.evseId)
        this.$dialog.notify.success(this.$t('charging-point.command-sended'))
      }).catch(err => {
        const reason = err.response && err.response.data && err.response.data.reason
        if (reason) {
          this.$dialog.notify.error(this.$t('charging-point.start-charge.refused', {reason}))
        } else {
          this.notifyError(err)
        }
      }).finally(() => {
        this.sending = false
      })
    },
  },
}
</script>
